@if(content) {
<div class="wrap-x wrap-l center">
    <div class="left w-4 w-12-m w-12-s p-l p-l-5-m p-b-4-s col-1">
        <div class="p-r-2-s">
            @if(!!popularSearches?.length || content.popular_searches_items?.length) {

            <h3 class="col-12 h3"
                *iCms="'popular_searches_title' of content; skipEmpty: true"></h3>

            }
            @if (!!popularSearches?.length) {
            @for(term of popularSearches; track $index) {
            <a class="w-12 m-t col-11 p2"
               [routerLink]="['search', term]">{{ term }}</a>
            }
            } @else {
            @if(content.popular_searches_items?.length) {
            @for(item of content.popular_searches_items; track $index) {
            <href class="m-t col-11 p2 block"
                  [link]="item.link">
                <span *iCms="'text' of item"></span>
            </href>
            }
            }
            }

        </div>
        @if(content.additional_title && content.additional_items) {
        <div class="p-r-2-s m-t-8 m-t-10-s">
            <h3 class="col-12 h3"
                *iCms="'additional_title' of content"></h3>

            @for(item of content.additional_items; track $index) {
            <href class="m-t col-11 p2 block"
                  [link]="item.link">
                <span *iCms="'text' of item"></span>
            </href>
            }
        </div>
        }
    </div>

    @if(content.trending_now_items ){
    <div class="wrap-s w-8 w-12-m w-12-s m-t-8-m m-t-6-s p-r-5-m p-l-5-m left">
        <h3 class="w-12 p-l-5 p-l-0-m p-l-0-s p-b-2"
            [sizeClass]="'!SM: h3 col-12, SM: o1 uppercase col-1'"
            *iCms="'trending_now_title' of content"></h3>
        <div class="w-12 m-t m-t-1-s p-l-1-x p-l-1-l">
            @for(item of content.trending_now_items; track $index; let isLast = $last) {
            <div class="c-4-set-x c-4-set-l c-6-set-m p-r-4-x p-r-4-l p-l-4-x p-l-4-l"
                 [ngClass]="isLast ? 'c-12-set-s m-t-4-s p-r-0-s' : 'c-6-set-s'">
                <href class="w-12"
                      [link]="item.link">
                    <div class="ratio-1-1 w-12">
                        <img class="rf"
                             [image]="item.image">
                    </div>

                    <div class="m-t-5 s2"
                         *iCms="'text' of item"></div>

                    <div class="m-t p2"
                         *iCms="'link_text' of item"></div>
                </href>
            </div>
            }
        </div>
    </div>
    }
</div>
}